// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import '@/mock'
import axios from 'axios'
import HttpUtils from './utils/http.js'
import permission  from './router/permission'

Vue.config.productionTip = false
Vue.use(ElementUI)
//配置axios到原型链中
Vue.prototype.axios = axios
Vue.prototype.$http = HttpUtils
new Vue({
  el: '#app',
  permission,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js